import React, {useEffect, useState} from 'react';
import {Button, Card, Col, Row} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import AppStateModel from "../../../models/appStateModel";
import {setLoading} from "../../../actions/common";
import Select from "react-select";
import LookupModel from "../../../models/lookupModel";
import {DateRangePicker} from "react-dates";
import {reportResponse, transactionReport} from "../../../models/codReports";
import {GetCodData, GetCodUserData} from "../../../api/data";
import moment from "moment";
import DynamicDataTable from "../../../components/dynamicDataTable";



const UsersTab = () => {
    const [ReturnDateFromFocusedInput, setReturnDateFromFocusedInput] = useState<any>();
    const [selectedCashier, setSelectedCashier] = useState<LookupModel>();
    const [startDate, setStartDate] = useState<Date>()
    const [endDate, setEndDate] = useState<Date>()
    const [data, setData] = useState<transactionReport>()
    const cashiers = useSelector((x: AppStateModel) => x.Meta?.cashiers)
    const dispatch = useDispatch()
    const refreshData = async (isExport?: boolean) => {
        dispatch(setLoading(true))
        const res = await GetCodUserData({
            filterId: selectedCashier?.value || "",
            dateFrom: startDate,
            dateTo: endDate,
            exportToExcel: isExport,
        })
        if (res.succeeded) {
            if (isExport) window.open(res.data.location, "_blank", "noreferrer");
            else {
                setData(res.data)
            }
        }
        dispatch(setLoading(false))
    }
    const onClear = () => {
        setSelectedCashier(undefined)
        setStartDate(undefined)
        setEndDate(undefined)
    }
    useEffect(() => {
        if(selectedCashier!=null){
            refreshData().then()
        }
    }, [selectedCashier, startDate, endDate])

    return (
        <div style={{margin: '10px 40px 0px'}}>
            <Card>
                <Card.Header>

                    <Row>
                        <Col lg={2} className="px-md-4">

                            <Select
                                key={`selectedCashier__${selectedCashier?.label}`}
                                value={selectedCashier}
                                styles={{control: customControlStyles}}
                                options={cashiers}
                                placeholder={"Member"}
                                onChange={(selectedOption) => {
                                    if (Array.isArray(selectedOption)) {
                                        throw new Error(
                                            "Unexpected type passed to ReactSelect onChange handler"
                                        );
                                    }
                                    setSelectedCashier({
                                        label: selectedOption?.label!,
                                        value: selectedOption?.value!,
                                    });
                                }}
                            />
                        </Col>
                        <Col lg={2} className="px-md-4">
                            <DateRangePicker
                                noBorder={false}
                                isOutsideRange={() => false}
                                small
                                minimumNights={0}
                                startDatePlaceholderText="Date from"
                                endDatePlaceholderText="Date To"
                                startDate={
                                    startDate ? moment(startDate) : null
                                }
                                startDateId="123" // PropTypes.string.isRequired,
                                endDate={
                                    startDate ? moment(endDate) : null
                                }
                                endDateId="321" // PropTypes.string.isRequired,
                                onDatesChange={({startDate, endDate}) => {
                                    setStartDate(startDate?.toDate());
                                    setEndDate(endDate?.toDate())
                                }}
                                focusedInput={ReturnDateFromFocusedInput}
                                onFocusChange={(focusedInput: any) => {
                                    setReturnDateFromFocusedInput(focusedInput);
                                }}
                            />

                        </Col>
                        <Col lg={2} className="px-md-4 mx-3">
                            <h5>Total Transactions: {data?.transactionsList.length?.toLocaleString()}</h5>
                        </Col>

                    </Row>
                    <div className="d-flex justify-content-end">
                        <Button disabled={!selectedCashier} variant={"danger"} onClick={onClear}>Clear</Button>
                        <div className="p-2"/>
                        <Button disabled={!selectedCashier || !Boolean(data?.transactionsList?.length)} onClick={() => refreshData(true)}>Export</Button>
                    </div>
                </Card.Header>
                <Card.Body>
                    <DynamicDataTable data={{matches:data?.transactionsList||[],total:data?.count||0}}/>
                </Card.Body>
            </Card>
        </div>
    )
}

const customControlStyles = (base: any) => ({
    ...base,
    height: 21!,
});


export default UsersTab;
